/* eslint-disable no-param-reassign */

import {
  types,
  getSnapshot,
  applySnapshot,
  addMiddleware,
} from "mobx-state-tree";
import ChatModel from "data/models/chat/live";
import WorkSessionModel from "data/models/workSession";
import HistoryChatsModel from "data/repositories/historyChats";
import LiveChatsModel from "data/repositories/liveChats";
import UserModel from "data/models/user";
import { mobxCaptureExeptionMiddleware } from "utils/mobx";
import TarotsRepository from "./repositories/tarots";
import TagsRepository from "./repositories/tags";

const findMobxNodeForChat = (identifier, parent) =>
  parent.chats.byId(identifier) ||
  parent.historyChats.byId(identifier) ||
  parent.archivedHistoryChats.byId(identifier) ||
  parent.workSessionChats.byId(identifier) ||
  parent.trialChats.byId(identifier);

const RootStore = types
  .model("Root", {
    user: types.maybeNull(UserModel, {}),
    workSession: types.maybeNull(WorkSessionModel),
    tarots: types.optional(TarotsRepository, {}),
    chats: types.optional(LiveChatsModel, {}),
    historyChats: types.optional(HistoryChatsModel, {}),
    archivedHistoryChats: types.optional(HistoryChatsModel, {}),
    workSessionChats: types.optional(HistoryChatsModel, {}),
    trialChats: types.optional(HistoryChatsModel, {}),
    tags: types.optional(TagsRepository, {}),
    activeChat: types.safeReference(ChatModel, {
      get: findMobxNodeForChat,
      set: (value) => value.id,
    }),
  })
  .actions((self) => ({
    afterCreate() {
      this.snapshot = getSnapshot(self);
    },

    reset() {
      applySnapshot(self, this.snapshot);
    },

    selectChat(chatId) {
      self.activeChat = chatId;
      return self;
    },

    setWorkSession(workSession) {
      self.workSession = workSession;
    },
    setUser(user) {
      self.user = user;
    },

    resetChats() {
      self.chats.removeAll();
      self.historyChats.removeAll();
      self.archivedHistoryChats.removeAll();
      self.workSessionChats.removeAll();
      self.trialChats.removeAll();
      self.selectChat(undefined);
    },
  }))
  .views((self) => ({
    byId(chatId) {
      return self.chats.byId(chatId) || self.byHistoryChatId(chatId);
    },
    byHistoryChatId(chatId) {
      return (
        self.historyChats.byId(chatId) ||
        self.archivedHistoryChats.byId(chatId) ||
        self.trialChats.byId(chatId) ||
        self.workSessionChats.byId(chatId)
      );
    },
    get workSessionAvailable() {
      return self.workSession && !self.workSession.endedAt;
    },
  }));

const store = RootStore.create();
export default store;

addMiddleware(store, mobxCaptureExeptionMiddleware);
